import { defineComponent as _defineComponent } from 'vue'
import CidadeService from '@/services/CidadeService';
import { useQuery } from '@tanstack/vue-query';
import { Cidade } from 'common/types/Cidade';
import { computed, defineComponent, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SeletorDeCidade',
  props: {
    value: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const { value } = __props as { value: Cidade | undefined };

defineComponent({
	inheritAttrs: true,
})



const busca = ref(value && value.nome)

const { data, isFetching } = useQuery({
	queryKey: ['cidades', busca],
	queryFn: async () => {
		const pagina = await CidadeService.findPage({ search: busca.value?.replace(/-/, '') })
		return pagina.items
	},
})



const computedItems = computed(() => {
  if (value && value.nome === busca.value) {
	return [value]
  }

  return data.value;
});

return { __sfc: true,busca, data, isFetching, emit, computedItems }
}

})